import { Injectable } from '@angular/core';
import {BaseDatabaseService} from '../../shared/services/databaseServices/BaseDatabaseService';
import * as firebase from 'firebase';
import {Router} from '@angular/router';

const TOKEN = 'TOKEN';
const LOGIN = 'LOGIN';
const ROLE = 'ROLE';

@Injectable({
  providedIn: 'root'
})
export class LoginService extends BaseDatabaseService {

  user;
  ADMIN = 'admin';
  ORGANIZATOR = 'organizator';
  private collectionName = 'users';
  private _role: string = undefined;

  constructor(private route: Router) {
    super();
  }

  loginWithEmail(email, password) {
    return firebase.auth().signInWithEmailAndPassword(email, password);
  }

  saveCurrentUser() {
    this.user = firebase.auth().currentUser;
    localStorage.setItem(LOGIN, this.user.email);
    this.user.getIdToken().then((token) => {
      localStorage.setItem(TOKEN, token);
      this.getRoles(this.user.email).then( data => {
        if (data.exists) {
          const d = data.data();
          d.role.get().then( role => {
            this.user._role = role.data();
            localStorage.setItem(ROLE, role.data().role);
            this._role = role.data().role;
          });
        } else{
          console.log("No such document!");
        }
      });
    });
  }

  getRoles(userMail: string) {
    // return this.db.collection(this.collectionName).doc(userMail).ref().get();

    return this.db.collection(this.collectionName).doc(userMail).get();
  }

  getLogin() {
    return localStorage.getItem(LOGIN);
  }

  isLogged() {
    const token = localStorage.getItem(TOKEN);
    return token != null;
    // return token != null ? !this.jwtHelper.isTokenExpired( token) : token != null;
  }

  destroyToken() {
    localStorage.removeItem(TOKEN);
    localStorage.removeItem(ROLE);
  }

  get role(): string {
    return localStorage.getItem(ROLE);
  }

  set role(value: string) {
    localStorage.setItem(ROLE, value);
  }

}
